import { getNextPageMappings } from './getNextPageMappings';

export const excludePageFromJourney = (progressionModel, pageSchemaModel, nextPageName, props) => {
    const nextPageMappingsList = getNextPageMappings();
    const getNextPageLink = progressionModel.getNextPageLink;
    const defaultRedirectResponse = getNextPageLink({ ...props, nextPageName }, pageSchemaModel.getUrlQualifier());
    if (nextPageMappingsList.length > 0) {
        const pageMapping = nextPageMappingsList.find((mapping) => mapping.hasOwnProperty(nextPageName));
        if (pageMapping) {
            return getNextPageLink({ ...props, nextPageName: pageMapping[nextPageName] || nextPageName }, pageSchemaModel.getUrlQualifier());
        }
    }
    return defaultRedirectResponse;
};

export const getExcludedPagesForPrefill = () => {
    const nextPageMappingsList = getNextPageMappings();
    return nextPageMappingsList.flatMap((page) => Object.keys(page));
};
